<template>
  <model-crud
    :model="model"
    :fields="fields"
    :include="['creator']"
    :editable="false"
    :deletable="false"
    default-order="created"
    :default-order-asc="false"
  >
    <template slot="creator" slot-scope="row">
      <div v-tooltip="{ content: row.item.creator ? `${row.item.creator.name} ${row.item.creator.surname}` : '?' }">
        {{ row.item.creator ? row.item.creator.username : '?' }}
      </div>
    </template>
    <template slot="dataBefore" slot-scope="row">
      <div v-tooltip="{ content: formatDataTooltip(model.getDiff(row.item, 'dataBefore')) }">
        {{ formatData(model.getDiff(row.item, 'dataBefore')) }}
      </div>
    </template>
    <template slot="dataAfter" slot-scope="row">
      <div v-tooltip="{ content: formatDataTooltip(model.getDiff(row.item, 'dataAfter')) }">
        {{ formatData(model.getDiff(row.item, 'dataAfter')) }}
      </div>
    </template>
    <!--<template slot="tableName" slot-scope="row">
        {{ fields.tableName.values[row.item.tableName] || row.item.tableName }}
    </template>-->
  </model-crud>
</template>

<script>
import ModelCrud from '@/components/ModelCrud'
import DataChange from '@/models/DataChange'
import User from '@/models/User'

export default {
  data () {
    return {
      model: DataChange,
      fields: {
        created: {
          label: this.$t('headers.changeDate'),
          type: 'date'
        },
        creator: {
          label: this.$t('headers.user'),
          type: 'reference',
          model: User,
          display: 'username'
        },
        tableName: {
          label: this.$t('headers.tableName'),
          values: DataChange.enums.tableName
        },
        operation: {
          label: this.$t('headers.operation'),
          type: 'enum',
          values: DataChange.enums.operation
        },
        dataBefore: {
          label: this.$t('headers.dataBefore'),
          type: 'data'
        },
        dataAfter: {
          label: this.$t('headers.dataAfter'),
          type: 'data'
        }
      }
    }
  },
  methods: {
    formatData (data) {
      let display = data.join(', ')
      if (display.length > 50) {
        display = display.substr(0, 47) + '...'
      }
      return display
    },
    formatDataTooltip (data) {
      return data.join('<br />')
    }
  },
  components: {
    ModelCrud
  }
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// DataChanges.vue?a49b8d52